<template>
  <EpisodeDialog
    v-model:edit-item="contextSelected"
    v-model:show-dialog="showDialog"/>
  <DataTable
    v-model:context-menu-selection="contextSelected"
    v-model:editing-rows="editingRows"
    v-model:selection="selections"
    :loading="loading"
    :rowClass="rowClass"
    :value="items"
    class="p-datatable-sm"
    column-resize-mode="fit"
    data-key="id"
    edit-mode="cell"
    removable-sort
    reorderable-columns
    resizable-columns
    responsive-layout="scroll"
    scroll-height="flex"
    scrollable
    selection-mode="single"
    show-gridlines
    sort-mode="single"
    state-key="Episodes-grid"
    state-storage="local"
    striped-rows
    @row-contextmenu="rowContextMenu"
    @cell-edit-complete="update">
    <template #header>
      <div class="flex justify-content-between align-items-center">
        <h3 class="p-text-secondary">Episodes</h3>
      </div>
    </template>
    <template #footer>
      <Toolbar>
        <template #start>
          <Button
            class="mx-1"
            icon="pi pi-plus"
            label="Add episode"
            @click="addRow()"/>
        </template>
        <template #end>
          In total there are {{ items?.length || 0 }} episodes.
        </template>
      </Toolbar>
    </template>
    <template #loading>
      Loading data. Please wait.
    </template>
    <template #empty>
      {{ error || "No Episodes." }}
    </template>
    <Column
      :sortable="true"
      class="table-row-min"
      field="name"
      header="Name"
      style="width: 20%">
      <template #editor="{ data, field }">
        <InputText
          v-model="data[field]"
          autofocus
          class="input-text"/>
      </template>
    </Column>
    <Column
      :sortable="true"
      field="title"
      header="Title"
      style="width: 30%">
      <template #editor="{ data, field }">
        <InputText
          v-model="data[field]"
          autofocus
          class="input-text"/>
      </template>
    </Column>
    <Column
      field="url"
      header="Dropbox"
      style="width: 20%">
      <template #body="{ data, field }">
        <span
          v-linkified
          v-html="data[field]"/>
      </template>
      <template #editor="{ data, field }">
        <InputText
          v-model="data[field]"
          autofocus
          class="input-text"/>
      </template>
    </Column>
  </DataTable>
  <ContextMenu :model="menuModel" ref="cm"/>
</template>
<script>

import EpisodesService from "@/services/entity/EpisodesService";
import GridService from "@/lib/GridService";
import EpisodeDialog from "@/views/editors/grid/dialog/EpisodeDialog";

export default {
  name: "EpisodesGrid",
  components: {EpisodeDialog},
  data() {
    return {
      changeState: {},
      showDialog: false,
      error: null,
      items: [],
      editingRows: [],
      selections: [],
      contextSelected: null,
      loading: true,
      menuModel: [
        {
          label: "Edit",
          icon: "pi pi-fw pi-pencil",
          command: () => this.openEditor(this.contextSelected)
        },
        {
          label: "Delete",
          icon: "pi pi-fw pi-times",
          command: () => this.deleteConfirm(this.contextSelected)
        }
      ]
    }
  },

  created() {
    this.service = new EpisodesService();
    this.gridService = new GridService();
  },

  mounted() {
    this.get()
  },

  methods: {
    get() {
      this.service.list().then(data => {
        if (!data.error) {
          this.items = data
          this.loading = false
        } else {
          this.error = data.message
        }
      }).catch(e => {
        this.error = e
        this.loading = false
      });
    },
    addRow() {
      this.contextSelected = this.gridService.addRow(this.items)
      this.openEditor()
    },
    update(event) {
      this.gridService.updateRowEvent(
        event,
        this.service,
        this.changeState,
        true
      )
    },
    delete(item) {
      this.gridService.delete(
        this.items,
        item,
        this.service,
        this.changeState
      )
    },
    deleteConfirm(item) {
      this.$confirm.require({
        group: "confirm",
        header: "Delete Confirmation",
        message: "Do you want to delete this record?",
        icon: "pi pi-times",
        acceptClass: "p-button-danger",
        accept: () => this.delete(item),
      });
    },
    rowContextMenu(event) {
      this.gridService.rowContextMenu(
        event,
        this.$refs.cm,
        this.contextSelected
      )
    },
    rowClass(item) {
      return this.gridService.rowClass(
        item,
        this.changeState
      )
    },
    openEditor() {
      this.showDialog = true
    },
  },
}
</script>
